import React, {ReactNode} from 'react';
import {Button, Modal, Text, Icon} from '@/ui-kits';
import { cn } from '@/utils/common_functions';

export type ConfirmModalProps = {
  onClose: () => void;
  onConfirm: () => void;
  header?: string;
  message?: ReactNode;
  warning?: ReactNode;
  subMessage?: ReactNode;
  open: boolean;
  cancelButtonText?: string;
  confirmButtonText?: string;
  showCloseIcon?: boolean;
  primaryCta?: 'cancel' | 'confirm'
  cancelButtonClassName?: string;
  confirmButtonClassName?: string;
};
export const ConfirmModal: React.FC<ConfirmModalProps> = props => {
  const {
    header,
    onClose,
    onConfirm,
    open,
    message,
    subMessage,
    cancelButtonText,
    confirmButtonText,
    showCloseIcon,
    primaryCta = 'cancel',
    warning,
    cancelButtonClassName,
    confirmButtonClassName,
  } = props;

  function handleConfirm() {
    onConfirm();
    onClose();
  }
  return (
    <Modal
      open={open}
      onClose={onClose}
      className="relative bg-white items-center py-5 xs:py-6 sm:py-8 px-4 xs:px-6 sm:px-12 rounded-xl gap-2.5 xs:gap-3 sm:gap-4 box-border w-fit overflow-y-auto">
      {showCloseIcon ? (
        <button className="absolute top-3 right-3 " onClick={onClose}>
          <Icon type="close" className="size-6 text-ui_blue " />
        </button>
      ) : null}
      {header && (
        <Text variant="title" className="pt-3 pb-3 whitespace-pre-line text-ui_blue text-center">
          {header}
        </Text>
      )}
      {message && (
        <Text variant="body" className="whitespace-pre-line text-ui_blue text-center leading-snug">
          {message}
        </Text>
      )}
      {warning && (
        <Text variant="body" className="whitespace-pre-line text-rejection text-center leading-snug">
          {warning}
        </Text>
      )}
      {subMessage && (
        <Text variant="small" className="text-ui_input_border_dark/60 text-center">
          {subMessage}
        </Text>
      )}
<div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full mt-3 sm:mt-4 justify-center items-center">
  <Button
    textClassName={'text-sm'}
    onClick={onClose}
    variant={primaryCta === 'cancel' ? 'primary' : 'secondary'}
    title={cancelButtonText || 'Cancel'}
    className={cn("w-[90%] sm:w-[200px] px-8 sm:px-10 py-2 border-[1px]", cancelButtonClassName)}
  />
  <Button
    textClassName={'text-sm'}
    variant={primaryCta === 'confirm' ? 'primary' : 'secondary'}
    onClick={handleConfirm}
    title={confirmButtonText || 'Confirm'}
    className={cn("w-[90%] sm:w-[200px] px-8 sm:px-10 py-2 border-[1px]", confirmButtonClassName)}
  />
</div>
    </Modal>
  );
};
